export default __webpack_public_path__ + "static/media/whatsappvector.5ab1f607.svg";